import { View, StyleSheet } from "react-native";
import CustomText from "../../common/general/CustomText/CustomText";
import AdminCompanionDocumentCard, { DocumentData } from "../AdminCompanionDocumentCard/AdminCompanionDocumentCard";

interface AdminCompanionDocumentCardListProps {
  documents: DocumentData[];
  onDelete?: (id: string) => void;
  onTogglePolicy?: (id: string, isPolicy: boolean) => void;
}

function AdminCompanionDocumentCardList({ documents, onDelete, onTogglePolicy }: AdminCompanionDocumentCardListProps) {
  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <CustomText
          text={`Uploaded Documents (${documents.length})`}
          size="s"
          weight="bold"
          useTranslationText={false}
          style={styles.title}
        />
      </View>

      {documents.length === 0 ? (
        <View style={styles.emptyState}>
          <CustomText text="No documents uploaded yet." size="s" useTranslationText={false} style={styles.emptyText} />
        </View>
      ) : (
        <View style={styles.list}>
          {documents.map((document) => (
            <AdminCompanionDocumentCard
              key={document.id}
              document={document}
              onDelete={onDelete}
              onTogglePolicy={onTogglePolicy}
            />
          ))}
        </View>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
  },
  header: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 16,
  },
  title: {
    color: "#101828",
  },
  list: {
    gap: 8,
  },
  emptyState: {
    paddingVertical: 24,
    alignItems: "center",
  },
  emptyText: {
    color: "#6B7280",
  },
});

export default AdminCompanionDocumentCardList;
